import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AdditionalPropertyInput = {
  activeCampaignCode?: InputMaybe<Scalars['String']>;
  backupPowerNeeds?: InputMaybe<Scalars['String']>;
  bankAccountValidated?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  complexBuildingName?: InputMaybe<Scalars['String']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customerType?: InputMaybe<Scalars['String']>;
  dwellingType?: InputMaybe<Scalars['String']>;
  electricityPhaseType?: InputMaybe<Scalars['String']>;
  electricityProvider?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<Scalars['String']>;
  fieldSalesAgent?: InputMaybe<Scalars['String']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  idPassportNumber?: InputMaybe<Scalars['String']>;
  insurance?: InputMaybe<Scalars['String']>;
  isRoofFlat?: InputMaybe<Scalars['Boolean']>;
  judgments?: InputMaybe<Scalars['Boolean']>;
  leadChannel?: InputMaybe<Scalars['String']>;
  meterType?: InputMaybe<Scalars['String']>;
  monthlyElectricitySpend?: InputMaybe<Scalars['Float']>;
  monthlyElectricityUsage?: InputMaybe<Scalars['Float']>;
  municipality?: InputMaybe<Scalars['String']>;
  originalCoCAvailable?: InputMaybe<Scalars['Boolean']>;
  passportUsed?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  propertyLat?: InputMaybe<Scalars['Float']>;
  propertyLng?: InputMaybe<Scalars['Float']>;
  propertyW3w?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  registeredBusinessNumber?: InputMaybe<Scalars['String']>;
  roofLat?: InputMaybe<Scalars['Float']>;
  roofLng?: InputMaybe<Scalars['Float']>;
  roofLocationConfirmed?: InputMaybe<Scalars['Boolean']>;
  roofType?: InputMaybe<Scalars['String']>;
  roofW3w?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<SelectedHubScriptionInput>;
  suburb?: InputMaybe<Scalars['String']>;
  teleSalesAgent?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
};

export type AgreementCustomerBankType = {
  accNumber?: InputMaybe<Scalars['String']>;
  accType?: InputMaybe<Scalars['String']>;
  bank?: InputMaybe<Scalars['String']>;
  branchCode?: InputMaybe<Scalars['String']>;
  customerName?: InputMaybe<Scalars['String']>;
  debitOrderDate?: InputMaybe<Scalars['String']>;
};

export type AgreementCustomerType = {
  address?: InputMaybe<Scalars['String']>;
  contactPerson?: InputMaybe<Scalars['String']>;
  customerCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  idNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<Scalars['String']>;
  premisesOwner?: InputMaybe<Scalars['String']>;
  telNo?: InputMaybe<Scalars['String']>;
};

export type AgreementDataInput = {
  additionalFlatRoofFee?: InputMaybe<Scalars['Int']>;
  adminFee?: InputMaybe<Scalars['Int']>;
  annualEscalationYear?: InputMaybe<Scalars['Int']>;
  batterySpecs?: InputMaybe<BatterySpecType>;
  callOutFee?: InputMaybe<Scalars['Int']>;
  customer?: InputMaybe<AgreementCustomerType>;
  customerBank?: InputMaybe<AgreementCustomerBankType>;
  deInstallationFee?: InputMaybe<Scalars['Int']>;
  fixedMonthlyFee?: InputMaybe<Scalars['Int']>;
  inverterSpecs?: InputMaybe<InverterSpecType>;
  purchasePrices?: InputMaybe<ProductPurchaseType>;
  reducedDeInstallationFee?: InputMaybe<Scalars['String']>;
  seller?: InputMaybe<SellerType>;
  sellerBank?: InputMaybe<SellerBankType>;
  signedAt?: InputMaybe<Scalars['String']>;
  signedDay?: InputMaybe<Scalars['String']>;
  signedMonthAndYear?: InputMaybe<Scalars['String']>;
  solarSystemSpecs?: InputMaybe<SolarSystemSpecType>;
  subscriptionName?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['String']>;
  upgradeFees?: InputMaybe<UpgradeFeesType>;
};

export type AlternateContact = {
  __typename?: 'AlternateContact';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type AlternateContactInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type AlternateContactResult = AlternateContact | ErrorResponse;

export type Bank = {
  __typename?: 'Bank';
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankAccountType?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
  debitOrderDate?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
};

export type BankInput = {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  branchCode?: InputMaybe<Scalars['String']>;
  debitOrderDate?: InputMaybe<Scalars['String']>;
  memberName?: InputMaybe<Scalars['String']>;
};

export type BankResult = Bank | ErrorResponse;

export type Banks = {
  __typename?: 'Banks';
  banks?: Maybe<Array<Maybe<Bank>>>;
};

export type BanksResult = Banks | ErrorResponse;

export type BatterySpecType = {
  capacity?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  premisesAndLayout?: InputMaybe<Scalars['String']>;
};

export type CallMe = {
  __typename?: 'CallMe';
  city?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  productOfInterest?: Maybe<Scalars['String']>;
  provinces?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
};

export type CallMeInput = {
  city?: InputMaybe<Scalars['String']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  productOfInterest?: InputMaybe<Scalars['String']>;
  provinces?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  suburb?: InputMaybe<Scalars['String']>;
};

export type CallMeResult = CallMe | ErrorResponse;

export type CreateUserInput = {
  contactNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<CreateUserPropertyInput>>>;
};

export type CreateUserPropertyInput = {
  backupPowerNeeds?: InputMaybe<Scalars['String']>;
  bankAccountValidated?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  complexBuildingName?: InputMaybe<Scalars['String']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customerType?: InputMaybe<Scalars['String']>;
  dwellingType?: InputMaybe<Scalars['String']>;
  electricityPhaseType?: InputMaybe<Scalars['String']>;
  electricityProvider?: InputMaybe<Scalars['String']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  insurance?: InputMaybe<Scalars['String']>;
  isRoofFlat?: InputMaybe<Scalars['String']>;
  judgments?: InputMaybe<Scalars['Boolean']>;
  meterType?: InputMaybe<Scalars['String']>;
  monthlyElectricitySpend?: InputMaybe<Scalars['String']>;
  originalCoCAvailable?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  propertyLat?: InputMaybe<Scalars['Float']>;
  propertyLng?: InputMaybe<Scalars['Float']>;
  propertyW3w?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  roofLat?: InputMaybe<Scalars['Float']>;
  roofLng?: InputMaybe<Scalars['Float']>;
  roofLocationConfirmed?: InputMaybe<Scalars['Boolean']>;
  roofType?: InputMaybe<Scalars['String']>;
  roofW3w?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<SubscriptionInput>;
  suburb?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
};

export type CreditCheckInput = {
  city?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  idPassportNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  recordId?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  suburb?: InputMaybe<Scalars['String']>;
  usePassportNumber?: InputMaybe<Scalars['Boolean']>;
};

export type CreditCheckResponse = {
  __typename?: 'CreditCheckResponse';
  message?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
};

export type CreditCheckResult = CreditCheckResponse | ErrorResponse;

export type CreditCheckUploadResponse = {
  __typename?: 'CreditCheckUploadResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type CreditCheckUploadResult = CreditCheckUploadResponse | ErrorResponse;

export type DebitOrderMandate = {
  __typename?: 'DebitOrderMandate';
  debitOrderMandate?: Maybe<Scalars['String']>;
};

export type DeviceDetails = {
  __typename?: 'DeviceDetails';
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type DeviceDetailsInput = {
  name?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type DeviceList = {
  __typename?: 'DeviceList';
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  error?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type EscalationPersonType = {
  __typename?: 'EscalationPersonType';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type EscalationTeamType = {
  __typename?: 'EscalationTeamType';
  cam?: Maybe<EscalationPersonType>;
  complianceOfficer?: Maybe<EscalationPersonType>;
  customerSuccessManager?: Maybe<EscalationPersonType>;
  cxSpecialist?: Maybe<EscalationPersonType>;
  supportSpecialist?: Maybe<EscalationPersonType>;
};

export type File = {
  __typename?: 'File';
  base64?: Maybe<Scalars['String']>;
};

export type FormDocuments = {
  __typename?: 'FormDocuments';
  documentFile?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
};

export type FormDocumentsResult = ErrorResponse | FormDocuments;

export type GetDebitOrderMandateResult = DebitOrderMandate | ErrorResponse;

export type GetFileResult = ErrorResponse | File;

export type GetSingleSubscriptionResult = ErrorResponse | Single_Subscription;

export type GetSubscriptionAgreementResult = ErrorResponse | SubscriptionAgreement;

export type GetSubscriptionsResult = ErrorResponse | Subscriptions;

export type InverterSpecType = {
  description?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  premisesAndLayout?: InputMaybe<Scalars['String']>;
};

export type KmlFile = {
  __typename?: 'KmlFile';
  kml?: Maybe<Scalars['String']>;
};

export type KmlResult = ErrorResponse | KmlFile;

export type Municipalities = {
  __typename?: 'Municipalities';
  municipalities?: Maybe<Array<Maybe<Municipality>>>;
};

export type MunicipalitiesResult = ErrorResponse | Municipalities;

export type Municipality = {
  __typename?: 'Municipality';
  legal_text?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAlternateContact?: Maybe<AlternateContactResult>;
  addBank?: Maybe<BankResult>;
  addUserProperty?: Maybe<UserAdditionalPropertyResult>;
  addUserPropertySubscription?: Maybe<SubscriptionResult>;
  createCallMe?: Maybe<CallMeResult>;
  createLead?: Maybe<UserResult>;
  createSubscriptionManagementQuery?: Maybe<SubscriptionManagementResult>;
  createSupportRequest?: Maybe<SupportRequestResult>;
  generateSignedDocuments?: Maybe<UserResult>;
  updateDynamoOnboardingSteps?: Maybe<UpdateDynamoOnboardingStepsResult>;
  updateDynamoUser?: Maybe<UserResult>;
  updateSolarman?: Maybe<SolarmanResult>;
  updateUser?: Maybe<UserResult>;
  updateUserProperty?: Maybe<UserPropertyResult>;
  uploadCreditCheckDocument?: Maybe<CreditCheckUploadResult>;
  uploadSignedDocument?: Maybe<UserResult>;
};


export type MutationAddAlternateContactArgs = {
  email: Scalars['String'];
  input: AlternateContactInput;
  recordId: Scalars['String'];
};


export type MutationAddBankArgs = {
  email: Scalars['String'];
  input: BankInput;
  recordId: Scalars['String'];
};


export type MutationAddUserPropertyArgs = {
  email: Scalars['String'];
  input: AdditionalPropertyInput;
};


export type MutationAddUserPropertySubscriptionArgs = {
  recordId: Scalars['String'];
  subscription?: InputMaybe<SubscriptionInput>;
};


export type MutationCreateCallMeArgs = {
  input: CallMeInput;
  public: Scalars['Boolean'];
};


export type MutationCreateLeadArgs = {
  input: CreateUserInput;
  public?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateSubscriptionManagementQueryArgs = {
  input: SubscriptionManagementInput;
};


export type MutationCreateSupportRequestArgs = {
  input: SupportRequestInput;
};


export type MutationGenerateSignedDocumentsArgs = {
  input?: InputMaybe<UpdateUserInput>;
  subscriptionData?: InputMaybe<AgreementDataInput>;
};


export type MutationUpdateDynamoOnboardingStepsArgs = {
  email: Scalars['String'];
  input: UpdateDynamoOnboardingStepsInput;
  recordId: Scalars['String'];
};


export type MutationUpdateDynamoUserArgs = {
  email: Scalars['String'];
  input: UpdateDynamoUserInput;
};


export type MutationUpdateSolarmanArgs = {
  input: SolarmanInput;
};


export type MutationUpdateUserArgs = {
  email: Scalars['String'];
  input: UpdateUserInput;
  public?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateUserPropertyArgs = {
  input: UpdateUserPropertyInput;
  recordId: Scalars['String'];
};


export type MutationUploadCreditCheckDocumentArgs = {
  input?: InputMaybe<CreditCheckInput>;
  recordId: Scalars['String'];
  score: Scalars['Int'];
};


export type MutationUploadSignedDocumentArgs = {
  input?: InputMaybe<UpdateUserInput>;
};

export type ProductFeesType = {
  de_installation_fee_first_3_Years?: InputMaybe<Scalars['String']>;
  de_installation_fee_then?: InputMaybe<Scalars['String']>;
  flat_Roof_Fee?: InputMaybe<Scalars['String']>;
  monthly_Fee?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  standard_Once_Off_Installation_Fee?: InputMaybe<Scalars['String']>;
  year_3?: InputMaybe<Scalars['Int']>;
  year_4?: InputMaybe<Scalars['Int']>;
  year_5?: InputMaybe<Scalars['Int']>;
  year_6?: InputMaybe<Scalars['Int']>;
  year_7?: InputMaybe<Scalars['Int']>;
};

export type ProductIdInput = {
  productId?: InputMaybe<Scalars['String']>;
};

export type ProductPurchaseType = {
  eight?: InputMaybe<Scalars['String']>;
  five?: InputMaybe<Scalars['Int']>;
  four?: InputMaybe<Scalars['Int']>;
  one?: InputMaybe<Scalars['String']>;
  seven?: InputMaybe<Scalars['Int']>;
  six?: InputMaybe<Scalars['Int']>;
  three?: InputMaybe<Scalars['Int']>;
  two?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getBanks?: Maybe<BanksResult>;
  getCreditScore?: Maybe<CreditCheckResult>;
  getDebitOrderMandate?: Maybe<GetDebitOrderMandateResult>;
  getFile?: Maybe<GetFileResult>;
  getFormDocuments?: Maybe<FormDocumentsResult>;
  getKml?: Maybe<KmlResult>;
  getMunicipalities?: Maybe<MunicipalitiesResult>;
  getSingleSubscription?: Maybe<GetSingleSubscriptionResult>;
  getSubscriptionAgreement?: Maybe<GetSubscriptionAgreementResult>;
  getSubscriptions?: Maybe<GetSubscriptionsResult>;
  getUser?: Maybe<UserResult>;
  getUserProperties?: Maybe<UserPropertiesResult>;
  getUserProperty?: Maybe<UserPropertyResult>;
  getUserSolarmanDeviceData?: Maybe<SolarmanDeviceCurrentDataResult>;
};


export type QueryGetCreditScoreArgs = {
  input?: InputMaybe<CreditCheckInput>;
};


export type QueryGetDebitOrderMandateArgs = {
  recordId: Scalars['String'];
};


export type QueryGetFileArgs = {
  key: Scalars['String'];
};


export type QueryGetKmlArgs = {
  public?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetSingleSubscriptionArgs = {
  productId: Scalars['String'];
};


export type QueryGetSubscriptionAgreementArgs = {
  recordId: Scalars['String'];
};


export type QueryGetUserArgs = {
  email: Scalars['String'];
  public?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetUserPropertiesArgs = {
  customerNumber: Scalars['String'];
};


export type QueryGetUserPropertyArgs = {
  recordId: Scalars['String'];
};


export type QueryGetUserSolarmanDeviceDataArgs = {
  input: SolarmanDeviceCurrentDataInput;
};

export type SelectedHubScription = {
  __typename?: 'SelectedHubScription';
  addOnBatteryComponentID?: Maybe<Scalars['Int']>;
  addOnPanelComponentID?: Maybe<Scalars['Int']>;
  baseProductID?: Maybe<Scalars['Int']>;
  baseProductName?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['String']>;
  numberOfAddOnBatteries?: Maybe<Scalars['Int']>;
  numberOfAddOnPanels?: Maybe<Scalars['Int']>;
};

export type SelectedHubScriptionInput = {
  addOnBatteryComponentID?: InputMaybe<Scalars['Int']>;
  addOnPanelComponentID?: InputMaybe<Scalars['Int']>;
  baseProductID?: InputMaybe<Scalars['Int']>;
  baseProductName?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<Scalars['String']>;
  numberOfAddOnBatteries?: InputMaybe<Scalars['Int']>;
  numberOfAddOnPanels?: InputMaybe<Scalars['Int']>;
};

export type SellerBankType = {
  bank?: InputMaybe<Scalars['String']>;
  branchCode?: InputMaybe<Scalars['String']>;
  electronicAccNumber?: InputMaybe<Scalars['String']>;
};

export type SellerType = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  registeredAddress?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
};

export type Single_Subscription = {
  __typename?: 'Single_Subscription';
  subscription?: Maybe<Array<Maybe<Subscription>>>;
};

export type SolarSystemSpecType = {
  additionalMaterials?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['String']>;
  de_installation_fee_first_3_Years?: InputMaybe<Scalars['String']>;
  expectedStructure?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  premisesAndLayout?: InputMaybe<Scalars['String']>;
};

export type SolarmanDeviceCurrentDataInput = {
  orderNumber?: InputMaybe<Scalars['String']>;
};

export type SolarmanDeviceCurrentDataItem = {
  __typename?: 'SolarmanDeviceCurrentDataItem';
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SolarmanDeviceCurrentDataResponse = {
  __typename?: 'SolarmanDeviceCurrentDataResponse';
  code?: Maybe<Scalars['String']>;
  dataList?: Maybe<Array<Maybe<SolarmanDeviceCurrentDataItem>>>;
  deviceId?: Maybe<Scalars['Int']>;
  deviceSn?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SolarmanDeviceCurrentDataResult = ErrorResponse | SolarmanDeviceCurrentDataResponse;

export type SolarmanInput = {
  batterySettings?: InputMaybe<Scalars['String']>;
  batteryTime1?: InputMaybe<Scalars['Float']>;
  batteryTime2?: InputMaybe<Scalars['Float']>;
  batteryTime3?: InputMaybe<Scalars['Float']>;
  batteryTime4?: InputMaybe<Scalars['Float']>;
  batteryTime5?: InputMaybe<Scalars['Float']>;
  batteryTime6?: InputMaybe<Scalars['Float']>;
  endTime1?: InputMaybe<Scalars['String']>;
  endTime2?: InputMaybe<Scalars['String']>;
  endTime3?: InputMaybe<Scalars['String']>;
  endTime4?: InputMaybe<Scalars['String']>;
  endTime5?: InputMaybe<Scalars['String']>;
  endTime6?: InputMaybe<Scalars['String']>;
  gridCharge1?: InputMaybe<Scalars['Boolean']>;
  gridCharge2?: InputMaybe<Scalars['Boolean']>;
  gridCharge3?: InputMaybe<Scalars['Boolean']>;
  gridCharge4?: InputMaybe<Scalars['Boolean']>;
  gridCharge5?: InputMaybe<Scalars['Boolean']>;
  gridCharge6?: InputMaybe<Scalars['Boolean']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  powerTime1?: InputMaybe<Scalars['String']>;
  powerTime2?: InputMaybe<Scalars['String']>;
  powerTime3?: InputMaybe<Scalars['String']>;
  powerTime4?: InputMaybe<Scalars['String']>;
  powerTime5?: InputMaybe<Scalars['String']>;
  powerTime6?: InputMaybe<Scalars['String']>;
  recordId?: InputMaybe<Scalars['String']>;
  startTime1?: InputMaybe<Scalars['String']>;
  startTime2?: InputMaybe<Scalars['String']>;
  startTime3?: InputMaybe<Scalars['String']>;
  startTime4?: InputMaybe<Scalars['String']>;
  startTime5?: InputMaybe<Scalars['String']>;
  startTime6?: InputMaybe<Scalars['String']>;
  time1?: InputMaybe<Scalars['Boolean']>;
  time2?: InputMaybe<Scalars['Boolean']>;
  time3?: InputMaybe<Scalars['Boolean']>;
  time4?: InputMaybe<Scalars['Boolean']>;
  time5?: InputMaybe<Scalars['Boolean']>;
  time6?: InputMaybe<Scalars['Boolean']>;
};

export type SolarmanResponse = {
  __typename?: 'SolarmanResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type SolarmanResult = ErrorResponse | SolarmanResponse;

export type Subscription = {
  __typename?: 'Subscription';
  addOns?: Maybe<Array<Maybe<Scalars['String']>>>;
  batteryCount?: Maybe<Scalars['String']>;
  batterySpec?: Maybe<Scalars['String']>;
  buyout_year_five?: Maybe<Scalars['Int']>;
  buyout_year_four?: Maybe<Scalars['Int']>;
  buyout_year_seven?: Maybe<Scalars['Int']>;
  buyout_year_six?: Maybe<Scalars['Int']>;
  buyout_year_three?: Maybe<Scalars['Int']>;
  de_installation_fee_after_year_three?: Maybe<Scalars['Int']>;
  de_installation_fee_year_one_to_three?: Maybe<Scalars['Int']>;
  flatRoofFee?: Maybe<Scalars['Int']>;
  inverterSpec?: Maybe<Scalars['String']>;
  onceOffFee?: Maybe<Scalars['Int']>;
  panelCount?: Maybe<Scalars['String']>;
  panelSpec?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['Int']>;
  subscriptionFee?: Maybe<Scalars['Int']>;
  subscriptionOption?: Maybe<Scalars['String']>;
  systemConfig?: Maybe<SelectedHubScription>;
};

export type SubscriptionAgreement = {
  __typename?: 'SubscriptionAgreement';
  subscriptionAgreement?: Maybe<Scalars['String']>;
};

export type SubscriptionInput = {
  addOns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  batteryCount?: InputMaybe<Scalars['Int']>;
  batterySpec?: InputMaybe<Scalars['String']>;
  buyout_year_five?: InputMaybe<Scalars['Int']>;
  buyout_year_four?: InputMaybe<Scalars['Int']>;
  buyout_year_seven?: InputMaybe<Scalars['Int']>;
  buyout_year_six?: InputMaybe<Scalars['Int']>;
  buyout_year_three?: InputMaybe<Scalars['Int']>;
  de_installation_fee_after_year_three?: InputMaybe<Scalars['Int']>;
  de_installation_fee_year_one_to_three?: InputMaybe<Scalars['Int']>;
  flatRoofFee?: InputMaybe<Scalars['Int']>;
  inverterSpec?: InputMaybe<Scalars['String']>;
  onceOffFee?: InputMaybe<Scalars['Int']>;
  panelCount?: InputMaybe<Scalars['String']>;
  panelSpec?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  productName?: InputMaybe<Scalars['String']>;
  recordId?: InputMaybe<Scalars['Int']>;
  subscriptionFee?: InputMaybe<Scalars['Int']>;
  subscriptionOption?: InputMaybe<Scalars['String']>;
};

export type SubscriptionManagement = {
  __typename?: 'SubscriptionManagement';
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  requestType?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
};

export type SubscriptionManagementInput = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  property?: InputMaybe<Scalars['String']>;
  requestType?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
};

export type SubscriptionManagementResult = ErrorResponse | SubscriptionManagement;

export type SubscriptionResult = ErrorResponse | Subscription;

export type Subscriptions = {
  __typename?: 'Subscriptions';
  subscriptions?: Maybe<Array<Maybe<Subscription>>>;
};

export type SupportRequest = {
  __typename?: 'SupportRequest';
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  preferredContactMethod?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  requestType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
};

export type SupportRequestInput = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preferredContactMethod?: InputMaybe<Scalars['String']>;
  requestType?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
};

export type SupportRequestResult = ErrorResponse | SupportRequest;

export type UpdateDynamoOnboardingSteps = {
  __typename?: 'UpdateDynamoOnboardingSteps';
  onboardingProgressCompletedStep?: Maybe<Scalars['Float']>;
  recordId?: Maybe<Scalars['String']>;
};

export type UpdateDynamoOnboardingStepsInput = {
  onboardingProgressCompletedStep?: InputMaybe<Scalars['Float']>;
};

export type UpdateDynamoOnboardingStepsResult = ErrorResponse | UpdateDynamoOnboardingSteps;

export type UpdateDynamoUserInput = {
  acceptedTermsAndConditions?: InputMaybe<Scalars['String']>;
  alternateNumber?: InputMaybe<Scalars['String']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  debitOrderDate?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  idPassportNumber?: InputMaybe<Scalars['String']>;
  initialOnboardingStarted?: InputMaybe<Scalars['Boolean']>;
  initials?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  memberName?: InputMaybe<Scalars['String']>;
  onboardingInProgress?: InputMaybe<Scalars['Boolean']>;
  onboardingProgressCompletedStep?: InputMaybe<Scalars['Float']>;
  promoCode?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<UpdateUserPropertyInput>>>;
  userDeviceDetails?: InputMaybe<UserDeviceDetailsInput>;
};

export type UpdateUserInput = {
  acceptedTermsAndConditions?: InputMaybe<Scalars['String']>;
  alternateNumber?: InputMaybe<Scalars['String']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  customerSignature?: InputMaybe<Scalars['String']>;
  debitOrderDate?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  idPassportNumber?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  memberName?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<UpdateUserPropertyInput>>>;
  recordId: Scalars['String'];
};

export type UpdateUserPropertyInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  activeBatterySettings?: InputMaybe<Scalars['String']>;
  additionalNotes?: InputMaybe<Scalars['String']>;
  backupPowerNeeds?: InputMaybe<Scalars['String']>;
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankAccountValidated?: InputMaybe<Scalars['Boolean']>;
  bankName?: InputMaybe<Scalars['String']>;
  branchCode?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  complexBuildingName?: InputMaybe<Scalars['String']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  coordinatesWithinBoundary?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  creditCheckPassed?: InputMaybe<Scalars['Boolean']>;
  customerType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dwellingType?: InputMaybe<Scalars['String']>;
  electricityPhaseType?: InputMaybe<Scalars['String']>;
  electricityProvider?: InputMaybe<Scalars['String']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  installationComplete?: InputMaybe<Scalars['Boolean']>;
  installationDate?: InputMaybe<Scalars['String']>;
  installationProcessInitiated?: InputMaybe<Scalars['Boolean']>;
  insurance?: InputMaybe<Scalars['String']>;
  isLawfulOwner?: InputMaybe<Scalars['Boolean']>;
  isRoofFlat?: InputMaybe<Scalars['String']>;
  judgments?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['String']>;
  locationVerified?: InputMaybe<Scalars['Boolean']>;
  longitude?: InputMaybe<Scalars['String']>;
  memberName?: InputMaybe<Scalars['String']>;
  meterType?: InputMaybe<Scalars['String']>;
  monthlyElectricitySpend?: InputMaybe<Scalars['String']>;
  onboardingProgressCompletedStep?: InputMaybe<Scalars['Float']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  originalCoCAvailable?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  propertyLat?: InputMaybe<Scalars['String']>;
  propertyLng?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  roofLat?: InputMaybe<Scalars['String']>;
  roofLng?: InputMaybe<Scalars['String']>;
  roofType?: InputMaybe<Scalars['String']>;
  ssegCompliancePassed?: InputMaybe<Scalars['Boolean']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<SubscriptionInput>;
  suburb?: InputMaybe<Scalars['String']>;
  tariff?: InputMaybe<Scalars['Float']>;
  unitNumber?: InputMaybe<Scalars['String']>;
  what3Words?: InputMaybe<Scalars['String']>;
};

export type UpgradeFeesType = {
  battery?: InputMaybe<Scalars['String']>;
  flatRoofFee?: InputMaybe<Scalars['String']>;
  panels?: InputMaybe<Scalars['String']>;
  upgrade?: InputMaybe<Scalars['String']>;
  upgradeFrom?: InputMaybe<Scalars['String']>;
  upgradeTo?: InputMaybe<Scalars['String']>;
  upgrade_plus_battery?: InputMaybe<Scalars['String']>;
  upgrade_plus_battery_plus_four_panels?: InputMaybe<Scalars['String']>;
  upgrade_plus_battery_plus_panels?: InputMaybe<Scalars['String']>;
  upgrade_plus_panels?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  acceptedTermsAndConditions?: Maybe<Scalars['String']>;
  alternateContact?: Maybe<AlternateContact>;
  alternateNumber?: Maybe<Scalars['String']>;
  avatarS3Key?: Maybe<Scalars['String']>;
  bankStatementsDocumentS3Key?: Maybe<Scalars['String']>;
  banks?: Maybe<Array<Maybe<UserBankDetails>>>;
  businessDesignation?: Maybe<Scalars['String']>;
  businessIndustry?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creditCheckDocumentS3Key?: Maybe<Scalars['String']>;
  customerNumber?: Maybe<Scalars['String']>;
  customerType?: Maybe<Scalars['String']>;
  debitOrderDate?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  escalationTeam?: Maybe<EscalationTeamType>;
  firstName?: Maybe<Scalars['String']>;
  idPassportDocumentS3Key?: Maybe<Scalars['String']>;
  idPassportNumber?: Maybe<Scalars['String']>;
  initialOnboardingStarted?: Maybe<Scalars['Boolean']>;
  initials?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  leadChannel?: Maybe<Scalars['String']>;
  legacyUser?: Maybe<Scalars['Boolean']>;
  nextOnboardingStep?: Maybe<Scalars['Int']>;
  onboardingInProgress?: Maybe<Scalars['Boolean']>;
  onboardingProgressCompletedStep?: Maybe<Scalars['Float']>;
  payslipsDocumentS3Key?: Maybe<Scalars['String']>;
  promoCode?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<UserProperty>>>;
  recordId?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  referralCodeTinyURL?: Maybe<Scalars['String']>;
  referralCount?: Maybe<Scalars['Int']>;
  registeredBusinessNumber?: Maybe<Scalars['String']>;
  registeredDate?: Maybe<Scalars['String']>;
  tradingName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userDeviceDetails?: Maybe<UserDeviceDetails>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type UserAdditionalProperty = {
  __typename?: 'UserAdditionalProperty';
  active?: Maybe<Scalars['Boolean']>;
  activeBatterySettings?: Maybe<Scalars['String']>;
  additionalNotes?: Maybe<Scalars['String']>;
  backupPowerNeeds?: Maybe<Scalars['String']>;
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankAccountType?: Maybe<Scalars['String']>;
  bankAccountValidated?: Maybe<Scalars['Boolean']>;
  bankName?: Maybe<Scalars['String']>;
  bankStatementDocument_01S3Key?: Maybe<Scalars['String']>;
  bankStatementDocument_02S3Key?: Maybe<Scalars['String']>;
  bankStatementDocument_03S3Key?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
  businessConsentDocumentS3Key?: Maybe<Scalars['String']>;
  businessRegistrationDocumentS3Key?: Maybe<Scalars['String']>;
  businessSuretyshipDocumentS3Key?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  complexBuildingName?: Maybe<Scalars['String']>;
  coordinatesWithinBoundary?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creditCheckPassed?: Maybe<Scalars['Boolean']>;
  customerId?: Maybe<Scalars['String']>;
  customerType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  directorSignatureS3Key?: Maybe<Scalars['String']>;
  dwellingType?: Maybe<Scalars['String']>;
  eclipseRecordId?: Maybe<Scalars['Int']>;
  electricalDistributionBoardPhotoS3Key?: Maybe<Scalars['String']>;
  electricityPhaseType?: Maybe<Scalars['String']>;
  electricityProvider?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  fieldAgent?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  hubRecordId?: Maybe<Scalars['Int']>;
  idPassportNumber?: Maybe<Scalars['String']>;
  installationComplete?: Maybe<Scalars['Boolean']>;
  installationDate?: Maybe<Scalars['String']>;
  installationLocationPhotoS3Key?: Maybe<Scalars['String']>;
  installationProcessInitiated?: Maybe<Scalars['Boolean']>;
  insurance?: Maybe<Scalars['String']>;
  isEclipseOrder?: Maybe<Scalars['Boolean']>;
  isGosolrManaged?: Maybe<Scalars['String']>;
  isLawfulOwner?: Maybe<Scalars['Boolean']>;
  isRoofFlat?: Maybe<Scalars['String']>;
  judgments?: Maybe<Scalars['Boolean']>;
  locationVerified?: Maybe<Scalars['Boolean']>;
  locationVettingCompletedStep?: Maybe<Scalars['Int']>;
  memberName?: Maybe<Scalars['String']>;
  meterType?: Maybe<Scalars['String']>;
  monthlyElectricitySpend?: Maybe<Scalars['String']>;
  onboardingProgressCompletedStep?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
  originalCoCAvailable?: Maybe<Scalars['Boolean']>;
  passportUsed?: Maybe<Scalars['Boolean']>;
  postalCode?: Maybe<Scalars['String']>;
  proofOfAddressS3Key?: Maybe<Scalars['String']>;
  proofOfOwnershipDocumentS3Key?: Maybe<Scalars['String']>;
  propertyLat?: Maybe<Scalars['String']>;
  propertyLng?: Maybe<Scalars['String']>;
  propertyW3w?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  registeredBusinessNumber?: Maybe<Scalars['String']>;
  roofLat?: Maybe<Scalars['String']>;
  roofLng?: Maybe<Scalars['String']>;
  roofPhotoS3Key?: Maybe<Scalars['String']>;
  roofType?: Maybe<Scalars['String']>;
  roofW3W?: Maybe<Scalars['String']>;
  ssegCompliancePassed?: Maybe<Scalars['Boolean']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  suburb?: Maybe<Scalars['String']>;
  tariff?: Maybe<Scalars['Float']>;
  taxClearanceDocumentS3Key?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  utilityBillDocumentS3Key?: Maybe<Scalars['String']>;
};

export type UserAdditionalPropertyResult = ErrorResponse | UserAdditionalProperty;

export type UserBankDetails = {
  __typename?: 'UserBankDetails';
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankAccountType?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
};

export type UserDeviceDetails = {
  __typename?: 'UserDeviceDetails';
  browser?: Maybe<DeviceDetails>;
  ip?: Maybe<Scalars['String']>;
  os?: Maybe<DeviceDetails>;
  timestamp?: Maybe<Scalars['String']>;
  what3Words?: Maybe<Scalars['String']>;
};

export type UserDeviceDetailsInput = {
  browser?: InputMaybe<DeviceDetailsInput>;
  ip?: InputMaybe<Scalars['String']>;
  os?: InputMaybe<DeviceDetailsInput>;
  timestamp?: InputMaybe<Scalars['String']>;
  what3Words?: InputMaybe<Scalars['String']>;
};

export type UserProperties = {
  __typename?: 'UserProperties';
  properties?: Maybe<Array<Maybe<UserProperty>>>;
};

export type UserPropertiesResult = ErrorResponse | UserProperties;

export type UserProperty = {
  __typename?: 'UserProperty';
  active?: Maybe<Scalars['Boolean']>;
  activeBatterySettings?: Maybe<Scalars['String']>;
  additionalNotes?: Maybe<Scalars['String']>;
  backupPowerNeeds?: Maybe<Scalars['String']>;
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankAccountType?: Maybe<Scalars['String']>;
  bankAccountValidated?: Maybe<Scalars['Boolean']>;
  bankName?: Maybe<Scalars['String']>;
  bankStatementDocument_01S3Key?: Maybe<Scalars['String']>;
  bankStatementDocument_02S3Key?: Maybe<Scalars['String']>;
  bankStatementDocument_03S3Key?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
  businessConsentDocumentS3Key?: Maybe<Scalars['String']>;
  businessDesignation?: Maybe<Scalars['String']>;
  businessIndustry?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  businessRegistrationDocumentS3Key?: Maybe<Scalars['String']>;
  businessSuretyshipDocumentS3Key?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  complexBuildingName?: Maybe<Scalars['String']>;
  coordinatesWithinBoundary?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creditCheckPassed?: Maybe<Scalars['Boolean']>;
  customerId?: Maybe<Scalars['String']>;
  customerType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  directorSignatureS3Key?: Maybe<Scalars['String']>;
  dwellingType?: Maybe<Scalars['String']>;
  eclipseRecordId?: Maybe<Scalars['Int']>;
  electricalDistributionBoardPhotoS3Key?: Maybe<Scalars['String']>;
  electricityPhaseType?: Maybe<Scalars['String']>;
  electricityProvider?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  fieldAgent?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  hubRecordId?: Maybe<Scalars['Int']>;
  idPassportNumber?: Maybe<Scalars['String']>;
  installationComplete?: Maybe<Scalars['Boolean']>;
  installationDate?: Maybe<Scalars['String']>;
  installationLocationPhotoS3Key?: Maybe<Scalars['String']>;
  installationProcessInitiated?: Maybe<Scalars['Boolean']>;
  insurance?: Maybe<Scalars['String']>;
  isEclipseOrder?: Maybe<Scalars['Boolean']>;
  isGosolrManaged?: Maybe<Scalars['String']>;
  isLawfulOwner?: Maybe<Scalars['Boolean']>;
  isRoofFlat?: Maybe<Scalars['String']>;
  judgments?: Maybe<Scalars['Boolean']>;
  locationVerified?: Maybe<Scalars['Boolean']>;
  locationVettingCompletedStep?: Maybe<Scalars['Int']>;
  memberName?: Maybe<Scalars['String']>;
  meterType?: Maybe<Scalars['String']>;
  monthlyElectricitySpend?: Maybe<Scalars['String']>;
  onboardingProgressCompletedStep?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
  originalCoCAvailable?: Maybe<Scalars['Boolean']>;
  passportUsed?: Maybe<Scalars['Boolean']>;
  postalCode?: Maybe<Scalars['String']>;
  proofOfAddressS3Key?: Maybe<Scalars['String']>;
  proofOfOwnershipDocumentS3Key?: Maybe<Scalars['String']>;
  propertyLat?: Maybe<Scalars['String']>;
  propertyLng?: Maybe<Scalars['String']>;
  propertyW3w?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  registeredBusinessNumber?: Maybe<Scalars['String']>;
  registeredDate?: Maybe<Scalars['String']>;
  roofLat?: Maybe<Scalars['String']>;
  roofLng?: Maybe<Scalars['String']>;
  roofPhotoS3Key?: Maybe<Scalars['String']>;
  roofType?: Maybe<Scalars['String']>;
  roofW3W?: Maybe<Scalars['String']>;
  ssegCompliancePassed?: Maybe<Scalars['Boolean']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  suburb?: Maybe<Scalars['String']>;
  tariff?: Maybe<Scalars['Float']>;
  taxClearanceDocumentS3Key?: Maybe<Scalars['String']>;
  tradingName?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  utilityBillDocumentS3Key?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type UserPropertyResult = ErrorResponse | UserProperty;

export type UserResult = ErrorResponse | User;

export type OnboardingStepsFragmentFragment = { __typename?: 'UpdateDynamoOnboardingSteps', recordId?: string | null, onboardingProgressCompletedStep?: number | null };

export type BankFragmentFragment = { __typename?: 'Bank', debitOrderDate?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null };

export type CreditCheckUploadFragmentFragment = { __typename?: 'CreditCheckUploadResponse', success?: boolean | null };

export type CreditCheckFragmentFragment = { __typename?: 'CreditCheckResponse', score?: number | null, risk?: string | null };

export type ErrorResponseFragmentFragment = { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null };

export type MunicipalitiesFragmentFragment = { __typename?: 'Municipalities', municipalities?: Array<{ __typename?: 'Municipality', recordId?: number | null, municipality?: string | null, legal_text?: string | null } | null> | null };

export type MunicipalityFragmentFragment = { __typename?: 'Municipality', recordId?: number | null, municipality?: string | null, legal_text?: string | null };

export type SolarmanDeviceDataFragment = { __typename?: 'SolarmanDeviceCurrentDataResponse', code?: string | null, key?: string | null, name?: string | null, unit?: string | null, value?: string | null, deviceId?: number | null, deviceSn?: string | null, dataList?: Array<{ __typename?: 'SolarmanDeviceCurrentDataItem', key?: string | null, value?: string | null, unit?: string | null, name?: string | null } | null> | null };

export type SubscriptionManagementFragmentFragment = { __typename?: 'SubscriptionManagement', recordId?: string | null };

export type SubscriptionFragmentFragment = { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null };

export type SupportRequestFragmentFragment = { __typename?: 'SupportRequest', recordId?: string | null, status?: string | null };

export type UserAdditionalPropertyFragmentFragment = { __typename?: 'UserAdditionalProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null };

export type UserPropertiesFragmentFragment = { __typename?: 'UserProperties', properties?: Array<{ __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null> | null };

export type UserPropertyFragmentFragment = { __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null };

export type UserFragmentFragment = { __typename?: 'User', email?: string | null, recordId?: string | null, initials?: string | null, firstName?: string | null, lastName?: string | null, contactNumber?: string | null, promoCode?: string | null, referralCode?: string | null, referralCodeTinyURL?: string | null, leadChannel?: string | null, customerType?: string | null, idPassportNumber?: string | null, customerNumber?: string | null, alternateNumber?: string | null, idPassportDocumentS3Key?: string | null, creditCheckDocumentS3Key?: string | null, bankStatementsDocumentS3Key?: string | null, payslipsDocumentS3Key?: string | null, avatarS3Key?: string | null, onboardingProgressCompletedStep?: number | null, initialOnboardingStarted?: boolean | null, onboardingInProgress?: boolean | null, nextOnboardingStep?: number | null, legacyUser?: boolean | null, debitOrderDate?: string | null, entityType?: string | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, acceptedTermsAndConditions?: string | null, banks?: Array<{ __typename?: 'UserBankDetails', memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null } | null> | null, properties?: Array<{ __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null> | null };

export type AddBankMutationVariables = Exact<{
  email: Scalars['String'];
  recordId: Scalars['String'];
  input: BankInput;
}>;


export type AddBankMutation = { __typename?: 'Mutation', addBank?: { __typename?: 'Bank', debitOrderDate?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null } | { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | null };

export type UploadCreditCheckDocumentMutationVariables = Exact<{
  recordId: Scalars['String'];
  score: Scalars['Int'];
  input: CreditCheckInput;
}>;


export type UploadCreditCheckDocumentMutation = { __typename?: 'Mutation', uploadCreditCheckDocument?: { __typename?: 'CreditCheckUploadResponse', success?: boolean | null } | { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | null };

export type UpdateDynamoOnboardingStepsMutationVariables = Exact<{
  email: Scalars['String'];
  recordId: Scalars['String'];
  input: UpdateDynamoOnboardingStepsInput;
}>;


export type UpdateDynamoOnboardingStepsMutation = { __typename?: 'Mutation', updateDynamoOnboardingSteps?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'UpdateDynamoOnboardingSteps', recordId?: string | null, onboardingProgressCompletedStep?: number | null } | null };

export type CreateLeadMutationVariables = Exact<{
  input: CreateUserInput;
  public: Scalars['Boolean'];
}>;


export type CreateLeadMutation = { __typename?: 'Mutation', createLead?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'User', email?: string | null, recordId?: string | null, initials?: string | null, firstName?: string | null, lastName?: string | null, contactNumber?: string | null, promoCode?: string | null, referralCode?: string | null, referralCodeTinyURL?: string | null, leadChannel?: string | null, customerType?: string | null, idPassportNumber?: string | null, customerNumber?: string | null, alternateNumber?: string | null, idPassportDocumentS3Key?: string | null, creditCheckDocumentS3Key?: string | null, bankStatementsDocumentS3Key?: string | null, payslipsDocumentS3Key?: string | null, avatarS3Key?: string | null, onboardingProgressCompletedStep?: number | null, initialOnboardingStarted?: boolean | null, onboardingInProgress?: boolean | null, nextOnboardingStep?: number | null, legacyUser?: boolean | null, debitOrderDate?: string | null, entityType?: string | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, acceptedTermsAndConditions?: string | null, banks?: Array<{ __typename?: 'UserBankDetails', memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null } | null> | null, properties?: Array<{ __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null> | null } | null };

export type CreateSubscriptionQueryMutationVariables = Exact<{
  input: SubscriptionManagementInput;
}>;


export type CreateSubscriptionQueryMutation = { __typename?: 'Mutation', createSubscriptionManagementQuery?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'SubscriptionManagement', recordId?: string | null } | null };

export type CreateSupportRequestMutationVariables = Exact<{
  input: SupportRequestInput;
}>;


export type CreateSupportRequestMutation = { __typename?: 'Mutation', createSupportRequest?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'SupportRequest', recordId?: string | null, status?: string | null } | null };

export type UpdateSolarmanMutationVariables = Exact<{
  input: SolarmanInput;
}>;


export type UpdateSolarmanMutation = { __typename?: 'Mutation', updateSolarman?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'SolarmanResponse', success?: boolean | null } | null };

export type AddUserPropertySubscriptionMutationVariables = Exact<{
  recordId: Scalars['String'];
  subscription: SubscriptionInput;
}>;


export type AddUserPropertySubscriptionMutation = { __typename?: 'Mutation', addUserPropertySubscription?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  email: Scalars['String'];
  input: UpdateUserInput;
  public?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'User', email?: string | null, recordId?: string | null, initials?: string | null, firstName?: string | null, lastName?: string | null, contactNumber?: string | null, promoCode?: string | null, referralCode?: string | null, referralCodeTinyURL?: string | null, leadChannel?: string | null, customerType?: string | null, idPassportNumber?: string | null, customerNumber?: string | null, alternateNumber?: string | null, idPassportDocumentS3Key?: string | null, creditCheckDocumentS3Key?: string | null, bankStatementsDocumentS3Key?: string | null, payslipsDocumentS3Key?: string | null, avatarS3Key?: string | null, onboardingProgressCompletedStep?: number | null, initialOnboardingStarted?: boolean | null, onboardingInProgress?: boolean | null, nextOnboardingStep?: number | null, legacyUser?: boolean | null, debitOrderDate?: string | null, entityType?: string | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, acceptedTermsAndConditions?: string | null, banks?: Array<{ __typename?: 'UserBankDetails', memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null } | null> | null, properties?: Array<{ __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null> | null } | null };

export type UpdateDynamoUserMutationVariables = Exact<{
  email: Scalars['String'];
  input: UpdateDynamoUserInput;
}>;


export type UpdateDynamoUserMutation = { __typename?: 'Mutation', updateDynamoUser?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'User', email?: string | null, recordId?: string | null, initials?: string | null, firstName?: string | null, lastName?: string | null, contactNumber?: string | null, promoCode?: string | null, referralCode?: string | null, referralCodeTinyURL?: string | null, leadChannel?: string | null, customerType?: string | null, idPassportNumber?: string | null, customerNumber?: string | null, alternateNumber?: string | null, idPassportDocumentS3Key?: string | null, creditCheckDocumentS3Key?: string | null, bankStatementsDocumentS3Key?: string | null, payslipsDocumentS3Key?: string | null, avatarS3Key?: string | null, onboardingProgressCompletedStep?: number | null, initialOnboardingStarted?: boolean | null, onboardingInProgress?: boolean | null, nextOnboardingStep?: number | null, legacyUser?: boolean | null, debitOrderDate?: string | null, entityType?: string | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, acceptedTermsAndConditions?: string | null, banks?: Array<{ __typename?: 'UserBankDetails', memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null } | null> | null, properties?: Array<{ __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null> | null } | null };

export type AddUserPropertyMutationVariables = Exact<{
  email: Scalars['String'];
  input: AdditionalPropertyInput;
}>;


export type AddUserPropertyMutation = { __typename?: 'Mutation', addUserProperty?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'UserAdditionalProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null };

export type UpdateUserPropertyMutationVariables = Exact<{
  recordId: Scalars['String'];
  input: UpdateUserPropertyInput;
}>;


export type UpdateUserPropertyMutation = { __typename?: 'Mutation', updateUserProperty?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null };

export type UploadSignedDocumentMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UploadSignedDocumentMutation = { __typename?: 'Mutation', uploadSignedDocument?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'User', email?: string | null, recordId?: string | null, initials?: string | null, firstName?: string | null, lastName?: string | null, contactNumber?: string | null, promoCode?: string | null, referralCode?: string | null, referralCodeTinyURL?: string | null, leadChannel?: string | null, customerType?: string | null, idPassportNumber?: string | null, customerNumber?: string | null, alternateNumber?: string | null, idPassportDocumentS3Key?: string | null, creditCheckDocumentS3Key?: string | null, bankStatementsDocumentS3Key?: string | null, payslipsDocumentS3Key?: string | null, avatarS3Key?: string | null, onboardingProgressCompletedStep?: number | null, initialOnboardingStarted?: boolean | null, onboardingInProgress?: boolean | null, nextOnboardingStep?: number | null, legacyUser?: boolean | null, debitOrderDate?: string | null, entityType?: string | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, acceptedTermsAndConditions?: string | null, banks?: Array<{ __typename?: 'UserBankDetails', memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null } | null> | null, properties?: Array<{ __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null> | null } | null };

export type GenerateSignedDocumentsMutationVariables = Exact<{
  input: UpdateUserInput;
  subscriptionData: AgreementDataInput;
}>;


export type GenerateSignedDocumentsMutation = { __typename?: 'Mutation', generateSignedDocuments?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'User', email?: string | null, recordId?: string | null, initials?: string | null, firstName?: string | null, lastName?: string | null, contactNumber?: string | null, promoCode?: string | null, referralCode?: string | null, referralCodeTinyURL?: string | null, leadChannel?: string | null, customerType?: string | null, idPassportNumber?: string | null, customerNumber?: string | null, alternateNumber?: string | null, idPassportDocumentS3Key?: string | null, creditCheckDocumentS3Key?: string | null, bankStatementsDocumentS3Key?: string | null, payslipsDocumentS3Key?: string | null, avatarS3Key?: string | null, onboardingProgressCompletedStep?: number | null, initialOnboardingStarted?: boolean | null, onboardingInProgress?: boolean | null, nextOnboardingStep?: number | null, legacyUser?: boolean | null, debitOrderDate?: string | null, entityType?: string | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, acceptedTermsAndConditions?: string | null, banks?: Array<{ __typename?: 'UserBankDetails', memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null } | null> | null, properties?: Array<{ __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null> | null } | null };

export type GetBanksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBanksQuery = { __typename?: 'Query', getBanks?: { __typename?: 'Banks', banks?: Array<{ __typename?: 'Bank', debitOrderDate?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null } | null> | null } | { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | null };

export type GetCreditScoreQueryVariables = Exact<{
  input: CreditCheckInput;
}>;


export type GetCreditScoreQuery = { __typename?: 'Query', getCreditScore?: { __typename?: 'CreditCheckResponse', score?: number | null, risk?: string | null } | { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | null };

export type GetKmlFileQueryVariables = Exact<{
  public?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetKmlFileQuery = { __typename?: 'Query', getKml?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'KmlFile', kml?: string | null } | null };

export type GetFileQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type GetFileQuery = { __typename?: 'Query', getFile?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'File', base64?: string | null } | null };

export type GetSubscriptionAgreementQueryVariables = Exact<{
  recordId: Scalars['String'];
}>;


export type GetSubscriptionAgreementQuery = { __typename?: 'Query', getSubscriptionAgreement?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'SubscriptionAgreement', subscriptionAgreement?: string | null } | null };

export type GetDebitOrderMandateQueryVariables = Exact<{
  recordId: Scalars['String'];
}>;


export type GetDebitOrderMandateQuery = { __typename?: 'Query', getDebitOrderMandate?: { __typename?: 'DebitOrderMandate', debitOrderMandate?: string | null } | { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | null };

export type GetMunicpalitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMunicpalitiesQuery = { __typename?: 'Query', getMunicipalities?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'Municipalities', municipalities?: Array<{ __typename?: 'Municipality', recordId?: number | null, municipality?: string | null, legal_text?: string | null } | null> | null } | null };

export type GetUserSolarmanDeviceDataQueryVariables = Exact<{
  input: SolarmanDeviceCurrentDataInput;
}>;


export type GetUserSolarmanDeviceDataQuery = { __typename?: 'Query', getUserSolarmanDeviceData?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'SolarmanDeviceCurrentDataResponse', code?: string | null, key?: string | null, name?: string | null, unit?: string | null, value?: string | null, deviceId?: number | null, deviceSn?: string | null, dataList?: Array<{ __typename?: 'SolarmanDeviceCurrentDataItem', key?: string | null, value?: string | null, unit?: string | null, name?: string | null } | null> | null } | null };

export type GetSingleSubscriptionsQueryVariables = Exact<{
  productId: Scalars['String'];
}>;


export type GetSingleSubscriptionsQuery = { __typename?: 'Query', getSingleSubscription?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'Single_Subscription', subscription?: Array<{ __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null> | null } | null };

export type GetSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionsQuery = { __typename?: 'Query', getSubscriptions?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'Subscriptions', subscriptions?: Array<{ __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null> | null } | null };

export type GetUserQueryVariables = Exact<{
  email: Scalars['String'];
  public?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'User', email?: string | null, recordId?: string | null, initials?: string | null, firstName?: string | null, lastName?: string | null, contactNumber?: string | null, promoCode?: string | null, referralCode?: string | null, referralCodeTinyURL?: string | null, leadChannel?: string | null, customerType?: string | null, idPassportNumber?: string | null, customerNumber?: string | null, alternateNumber?: string | null, idPassportDocumentS3Key?: string | null, creditCheckDocumentS3Key?: string | null, bankStatementsDocumentS3Key?: string | null, payslipsDocumentS3Key?: string | null, avatarS3Key?: string | null, onboardingProgressCompletedStep?: number | null, initialOnboardingStarted?: boolean | null, onboardingInProgress?: boolean | null, nextOnboardingStep?: number | null, legacyUser?: boolean | null, debitOrderDate?: string | null, entityType?: string | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, acceptedTermsAndConditions?: string | null, banks?: Array<{ __typename?: 'UserBankDetails', memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null } | null> | null, properties?: Array<{ __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null> | null } | null };

export type GetUserPropertyQueryVariables = Exact<{
  recordId: Scalars['String'];
}>;


export type GetUserPropertyQuery = { __typename?: 'Query', getUserProperty?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null };

export type GetUserPropertiesQueryVariables = Exact<{
  customerNumber: Scalars['String'];
}>;


export type GetUserPropertiesQuery = { __typename?: 'Query', getUserProperties?: { __typename?: 'ErrorResponse', type?: string | null, message?: string | null, error?: boolean | null } | { __typename?: 'UserProperties', properties?: Array<{ __typename?: 'UserProperty', isEclipseOrder?: boolean | null, recordId?: string | null, eclipseRecordId?: number | null, coordinatesWithinBoundary?: boolean | null, propertyW3w?: string | null, fullAddress?: string | null, streetAddress?: string | null, streetNumber?: string | null, streetName?: string | null, suburb?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, propertyLat?: string | null, propertyLng?: string | null, monthlyElectricitySpend?: string | null, roofType?: string | null, electricityPhaseType?: string | null, meterType?: string | null, orderNumber?: string | null, orderStatus?: string | null, dwellingType?: string | null, customerType?: string | null, complexBuildingName?: string | null, active?: boolean | null, installationProcessInitiated?: boolean | null, installationComplete?: boolean | null, installationDate?: string | null, locationVerified?: boolean | null, insurance?: string | null, ssegCompliancePassed?: boolean | null, creditCheckPassed?: boolean | null, proofOfAddressS3Key?: string | null, activeBatterySettings?: string | null, isGosolrManaged?: string | null, memberName?: string | null, bankName?: string | null, branchCode?: string | null, bankAccountType?: string | null, bankAccountNumber?: string | null, electricityProvider?: string | null, additionalNotes?: string | null, fieldAgent?: string | null, isRoofFlat?: string | null, roofLat?: string | null, roofLng?: string | null, roofW3W?: string | null, backupPowerNeeds?: string | null, utilityBillDocumentS3Key?: string | null, installationLocationPhotoS3Key?: string | null, roofPhotoS3Key?: string | null, electricalDistributionBoardPhotoS3Key?: string | null, bankStatementDocument_01S3Key?: string | null, bankStatementDocument_02S3Key?: string | null, bankStatementDocument_03S3Key?: string | null, businessRegistrationDocumentS3Key?: string | null, proofOfOwnershipDocumentS3Key?: string | null, taxClearanceDocumentS3Key?: string | null, businessSuretyshipDocumentS3Key?: string | null, businessConsentDocumentS3Key?: string | null, isLawfulOwner?: boolean | null, entityType?: string | null, idPassportNumber?: string | null, passportUsed?: boolean | null, directorSignatureS3Key?: string | null, originalCoCAvailable?: boolean | null, onboardingProgressCompletedStep?: number | null, businessName?: string | null, registeredBusinessNumber?: string | null, registeredDate?: string | null, businessIndustry?: string | null, tradingName?: string | null, vatNumber?: string | null, businessDesignation?: string | null, subscription?: { __typename?: 'Subscription', recordId?: number | null, productName?: string | null, productId?: number | null, subscriptionOption?: string | null, addOns?: Array<string | null> | null, onceOffFee?: number | null, subscriptionFee?: number | null, flatRoofFee?: number | null, inverterSpec?: string | null, batterySpec?: string | null, batteryCount?: string | null, panelSpec?: string | null, panelCount?: string | null, buyout_year_three?: number | null, buyout_year_four?: number | null, buyout_year_five?: number | null, buyout_year_six?: number | null, buyout_year_seven?: number | null, de_installation_fee_year_one_to_three?: number | null, de_installation_fee_after_year_three?: number | null, systemConfig?: { __typename?: 'SelectedHubScription', division?: string | null, baseProductID?: number | null, baseProductName?: string | null, addOnPanelComponentID?: number | null, addOnBatteryComponentID?: number | null, numberOfAddOnBatteries?: number | null, numberOfAddOnPanels?: number | null } | null } | null } | null> | null } | null };

export const OnboardingStepsFragmentFragmentDoc = gql`
    fragment OnboardingStepsFragment on UpdateDynamoOnboardingSteps {
  recordId
  onboardingProgressCompletedStep
}
    `;
export const BankFragmentFragmentDoc = gql`
    fragment BankFragment on Bank {
  debitOrderDate
  memberName
  bankName
  branchCode
  bankAccountType
  bankAccountNumber
}
    `;
export const CreditCheckUploadFragmentFragmentDoc = gql`
    fragment CreditCheckUploadFragment on CreditCheckUploadResponse {
  success
}
    `;
export const CreditCheckFragmentFragmentDoc = gql`
    fragment CreditCheckFragment on CreditCheckResponse {
  score
  risk
}
    `;
export const ErrorResponseFragmentFragmentDoc = gql`
    fragment ErrorResponseFragment on ErrorResponse {
  type
  message
  error
}
    `;
export const MunicipalityFragmentFragmentDoc = gql`
    fragment MunicipalityFragment on Municipality {
  recordId
  municipality
  legal_text
}
    `;
export const MunicipalitiesFragmentFragmentDoc = gql`
    fragment MunicipalitiesFragment on Municipalities {
  municipalities {
    ...MunicipalityFragment
  }
}
    ${MunicipalityFragmentFragmentDoc}`;
export const SolarmanDeviceDataFragmentDoc = gql`
    fragment SolarmanDeviceData on SolarmanDeviceCurrentDataResponse {
  code
  dataList {
    key
    value
    unit
    name
  }
  key
  name
  unit
  value
  deviceId
  deviceSn
}
    `;
export const SubscriptionManagementFragmentFragmentDoc = gql`
    fragment SubscriptionManagementFragment on SubscriptionManagement {
  recordId
}
    `;
export const SupportRequestFragmentFragmentDoc = gql`
    fragment SupportRequestFragment on SupportRequest {
  recordId
  status
}
    `;
export const SubscriptionFragmentFragmentDoc = gql`
    fragment SubscriptionFragment on Subscription {
  systemConfig {
    division
    baseProductID
    baseProductName
    addOnPanelComponentID
    addOnBatteryComponentID
    numberOfAddOnBatteries
    numberOfAddOnPanels
  }
  recordId
  productName
  productId
  subscriptionOption
  addOns
  onceOffFee
  subscriptionFee
  flatRoofFee
  inverterSpec
  batterySpec
  batteryCount
  panelSpec
  panelCount
  buyout_year_three
  buyout_year_four
  buyout_year_five
  buyout_year_six
  buyout_year_seven
  de_installation_fee_year_one_to_three
  de_installation_fee_after_year_three
}
    `;
export const UserAdditionalPropertyFragmentFragmentDoc = gql`
    fragment UserAdditionalPropertyFragment on UserAdditionalProperty {
  isEclipseOrder
  recordId
  eclipseRecordId
  coordinatesWithinBoundary
  propertyW3w
  fullAddress
  streetAddress
  streetNumber
  streetName
  suburb
  city
  province
  postalCode
  propertyLat
  propertyLng
  monthlyElectricitySpend
  roofType
  electricityPhaseType
  meterType
  orderNumber
  orderStatus
  dwellingType
  customerType
  complexBuildingName
  active
  installationProcessInitiated
  installationComplete
  installationDate
  locationVerified
  insurance
  ssegCompliancePassed
  creditCheckPassed
  proofOfAddressS3Key
  activeBatterySettings
  isGosolrManaged
  memberName
  bankName
  branchCode
  bankAccountType
  bankAccountNumber
  electricityProvider
  additionalNotes
  fieldAgent
  subscription {
    ...SubscriptionFragment
  }
  isRoofFlat
  roofLat
  roofLng
  roofW3W
  backupPowerNeeds
  utilityBillDocumentS3Key
  installationLocationPhotoS3Key
  roofPhotoS3Key
  electricalDistributionBoardPhotoS3Key
  bankStatementDocument_01S3Key
  bankStatementDocument_02S3Key
  bankStatementDocument_03S3Key
  businessRegistrationDocumentS3Key
  proofOfOwnershipDocumentS3Key
  taxClearanceDocumentS3Key
  businessSuretyshipDocumentS3Key
  businessConsentDocumentS3Key
  isLawfulOwner
  entityType
  idPassportNumber
  passportUsed
  directorSignatureS3Key
  originalCoCAvailable
  onboardingProgressCompletedStep
}
    ${SubscriptionFragmentFragmentDoc}`;
export const UserPropertyFragmentFragmentDoc = gql`
    fragment UserPropertyFragment on UserProperty {
  isEclipseOrder
  recordId
  eclipseRecordId
  coordinatesWithinBoundary
  propertyW3w
  fullAddress
  streetAddress
  streetNumber
  streetName
  suburb
  city
  province
  postalCode
  propertyLat
  propertyLng
  monthlyElectricitySpend
  roofType
  electricityPhaseType
  meterType
  orderNumber
  orderStatus
  dwellingType
  customerType
  complexBuildingName
  active
  installationProcessInitiated
  installationComplete
  installationDate
  locationVerified
  insurance
  ssegCompliancePassed
  creditCheckPassed
  proofOfAddressS3Key
  activeBatterySettings
  isGosolrManaged
  memberName
  bankName
  branchCode
  bankAccountType
  bankAccountNumber
  electricityProvider
  additionalNotes
  fieldAgent
  subscription {
    ...SubscriptionFragment
  }
  isRoofFlat
  roofLat
  roofLng
  roofW3W
  backupPowerNeeds
  utilityBillDocumentS3Key
  installationLocationPhotoS3Key
  roofPhotoS3Key
  electricalDistributionBoardPhotoS3Key
  bankStatementDocument_01S3Key
  bankStatementDocument_02S3Key
  bankStatementDocument_03S3Key
  businessRegistrationDocumentS3Key
  proofOfOwnershipDocumentS3Key
  taxClearanceDocumentS3Key
  businessSuretyshipDocumentS3Key
  businessConsentDocumentS3Key
  isLawfulOwner
  entityType
  idPassportNumber
  passportUsed
  directorSignatureS3Key
  originalCoCAvailable
  onboardingProgressCompletedStep
  businessName
  registeredBusinessNumber
  registeredDate
  businessIndustry
  tradingName
  vatNumber
  businessDesignation
}
    ${SubscriptionFragmentFragmentDoc}`;
export const UserPropertiesFragmentFragmentDoc = gql`
    fragment UserPropertiesFragment on UserProperties {
  properties {
    ...UserPropertyFragment
  }
}
    ${UserPropertyFragmentFragmentDoc}`;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  email
  recordId
  initials
  firstName
  lastName
  contactNumber
  promoCode
  referralCode
  referralCodeTinyURL
  leadChannel
  customerType
  idPassportNumber
  customerNumber
  alternateNumber
  idPassportDocumentS3Key
  creditCheckDocumentS3Key
  bankStatementsDocumentS3Key
  payslipsDocumentS3Key
  avatarS3Key
  onboardingProgressCompletedStep
  initialOnboardingStarted
  onboardingInProgress
  nextOnboardingStep
  legacyUser
  debitOrderDate
  banks {
    memberName
    bankName
    branchCode
    bankAccountType
    bankAccountNumber
  }
  properties {
    ...UserPropertyFragment
  }
  entityType
  businessName
  registeredBusinessNumber
  registeredDate
  businessIndustry
  tradingName
  vatNumber
  businessDesignation
  acceptedTermsAndConditions
}
    ${UserPropertyFragmentFragmentDoc}`;
export const AddBankDocument = gql`
    mutation AddBank($email: String!, $recordId: String!, $input: BankInput!) {
  addBank(email: $email, recordId: $recordId, input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on Bank {
      ...BankFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${BankFragmentFragmentDoc}`;
export type AddBankMutationFn = Apollo.MutationFunction<AddBankMutation, AddBankMutationVariables>;

/**
 * __useAddBankMutation__
 *
 * To run a mutation, you first call `useAddBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBankMutation, { data, loading, error }] = useAddBankMutation({
 *   variables: {
 *      email: // value for 'email'
 *      recordId: // value for 'recordId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBankMutation(baseOptions?: Apollo.MutationHookOptions<AddBankMutation, AddBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBankMutation, AddBankMutationVariables>(AddBankDocument, options);
      }
export type AddBankMutationHookResult = ReturnType<typeof useAddBankMutation>;
export type AddBankMutationResult = Apollo.MutationResult<AddBankMutation>;
export type AddBankMutationOptions = Apollo.BaseMutationOptions<AddBankMutation, AddBankMutationVariables>;
export const UploadCreditCheckDocumentDocument = gql`
    mutation UploadCreditCheckDocument($recordId: String!, $score: Int!, $input: CreditCheckInput!) {
  uploadCreditCheckDocument(recordId: $recordId, score: $score, input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on CreditCheckUploadResponse {
      ...CreditCheckUploadFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${CreditCheckUploadFragmentFragmentDoc}`;
export type UploadCreditCheckDocumentMutationFn = Apollo.MutationFunction<UploadCreditCheckDocumentMutation, UploadCreditCheckDocumentMutationVariables>;

/**
 * __useUploadCreditCheckDocumentMutation__
 *
 * To run a mutation, you first call `useUploadCreditCheckDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCreditCheckDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCreditCheckDocumentMutation, { data, loading, error }] = useUploadCreditCheckDocumentMutation({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      score: // value for 'score'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCreditCheckDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadCreditCheckDocumentMutation, UploadCreditCheckDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCreditCheckDocumentMutation, UploadCreditCheckDocumentMutationVariables>(UploadCreditCheckDocumentDocument, options);
      }
export type UploadCreditCheckDocumentMutationHookResult = ReturnType<typeof useUploadCreditCheckDocumentMutation>;
export type UploadCreditCheckDocumentMutationResult = Apollo.MutationResult<UploadCreditCheckDocumentMutation>;
export type UploadCreditCheckDocumentMutationOptions = Apollo.BaseMutationOptions<UploadCreditCheckDocumentMutation, UploadCreditCheckDocumentMutationVariables>;
export const UpdateDynamoOnboardingStepsDocument = gql`
    mutation UpdateDynamoOnboardingSteps($email: String!, $recordId: String!, $input: UpdateDynamoOnboardingStepsInput!) {
  updateDynamoOnboardingSteps(email: $email, recordId: $recordId, input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on UpdateDynamoOnboardingSteps {
      ...OnboardingStepsFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${OnboardingStepsFragmentFragmentDoc}`;
export type UpdateDynamoOnboardingStepsMutationFn = Apollo.MutationFunction<UpdateDynamoOnboardingStepsMutation, UpdateDynamoOnboardingStepsMutationVariables>;

/**
 * __useUpdateDynamoOnboardingStepsMutation__
 *
 * To run a mutation, you first call `useUpdateDynamoOnboardingStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDynamoOnboardingStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDynamoOnboardingStepsMutation, { data, loading, error }] = useUpdateDynamoOnboardingStepsMutation({
 *   variables: {
 *      email: // value for 'email'
 *      recordId: // value for 'recordId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDynamoOnboardingStepsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDynamoOnboardingStepsMutation, UpdateDynamoOnboardingStepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDynamoOnboardingStepsMutation, UpdateDynamoOnboardingStepsMutationVariables>(UpdateDynamoOnboardingStepsDocument, options);
      }
export type UpdateDynamoOnboardingStepsMutationHookResult = ReturnType<typeof useUpdateDynamoOnboardingStepsMutation>;
export type UpdateDynamoOnboardingStepsMutationResult = Apollo.MutationResult<UpdateDynamoOnboardingStepsMutation>;
export type UpdateDynamoOnboardingStepsMutationOptions = Apollo.BaseMutationOptions<UpdateDynamoOnboardingStepsMutation, UpdateDynamoOnboardingStepsMutationVariables>;
export const CreateLeadDocument = gql`
    mutation CreateLead($input: CreateUserInput!, $public: Boolean!) {
  createLead(input: $input, public: $public) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on User {
      ...UserFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export type CreateLeadMutationFn = Apollo.MutationFunction<CreateLeadMutation, CreateLeadMutationVariables>;

/**
 * __useCreateLeadMutation__
 *
 * To run a mutation, you first call `useCreateLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadMutation, { data, loading, error }] = useCreateLeadMutation({
 *   variables: {
 *      input: // value for 'input'
 *      public: // value for 'public'
 *   },
 * });
 */
export function useCreateLeadMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadMutation, CreateLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadMutation, CreateLeadMutationVariables>(CreateLeadDocument, options);
      }
export type CreateLeadMutationHookResult = ReturnType<typeof useCreateLeadMutation>;
export type CreateLeadMutationResult = Apollo.MutationResult<CreateLeadMutation>;
export type CreateLeadMutationOptions = Apollo.BaseMutationOptions<CreateLeadMutation, CreateLeadMutationVariables>;
export const CreateSubscriptionQueryDocument = gql`
    mutation CreateSubscriptionQuery($input: SubscriptionManagementInput!) {
  createSubscriptionManagementQuery(input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on SubscriptionManagement {
      ...SubscriptionManagementFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${SubscriptionManagementFragmentFragmentDoc}`;
export type CreateSubscriptionQueryMutationFn = Apollo.MutationFunction<CreateSubscriptionQueryMutation, CreateSubscriptionQueryMutationVariables>;

/**
 * __useCreateSubscriptionQueryMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionQueryMutation, { data, loading, error }] = useCreateSubscriptionQueryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionQueryMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionQueryMutation, CreateSubscriptionQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionQueryMutation, CreateSubscriptionQueryMutationVariables>(CreateSubscriptionQueryDocument, options);
      }
export type CreateSubscriptionQueryMutationHookResult = ReturnType<typeof useCreateSubscriptionQueryMutation>;
export type CreateSubscriptionQueryMutationResult = Apollo.MutationResult<CreateSubscriptionQueryMutation>;
export type CreateSubscriptionQueryMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionQueryMutation, CreateSubscriptionQueryMutationVariables>;
export const CreateSupportRequestDocument = gql`
    mutation CreateSupportRequest($input: SupportRequestInput!) {
  createSupportRequest(input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on SupportRequest {
      ...SupportRequestFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${SupportRequestFragmentFragmentDoc}`;
export type CreateSupportRequestMutationFn = Apollo.MutationFunction<CreateSupportRequestMutation, CreateSupportRequestMutationVariables>;

/**
 * __useCreateSupportRequestMutation__
 *
 * To run a mutation, you first call `useCreateSupportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportRequestMutation, { data, loading, error }] = useCreateSupportRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupportRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupportRequestMutation, CreateSupportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupportRequestMutation, CreateSupportRequestMutationVariables>(CreateSupportRequestDocument, options);
      }
export type CreateSupportRequestMutationHookResult = ReturnType<typeof useCreateSupportRequestMutation>;
export type CreateSupportRequestMutationResult = Apollo.MutationResult<CreateSupportRequestMutation>;
export type CreateSupportRequestMutationOptions = Apollo.BaseMutationOptions<CreateSupportRequestMutation, CreateSupportRequestMutationVariables>;
export const UpdateSolarmanDocument = gql`
    mutation updateSolarman($input: SolarmanInput!) {
  updateSolarman(input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on SolarmanResponse {
      success
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}`;
export type UpdateSolarmanMutationFn = Apollo.MutationFunction<UpdateSolarmanMutation, UpdateSolarmanMutationVariables>;

/**
 * __useUpdateSolarmanMutation__
 *
 * To run a mutation, you first call `useUpdateSolarmanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSolarmanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSolarmanMutation, { data, loading, error }] = useUpdateSolarmanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSolarmanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSolarmanMutation, UpdateSolarmanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSolarmanMutation, UpdateSolarmanMutationVariables>(UpdateSolarmanDocument, options);
      }
export type UpdateSolarmanMutationHookResult = ReturnType<typeof useUpdateSolarmanMutation>;
export type UpdateSolarmanMutationResult = Apollo.MutationResult<UpdateSolarmanMutation>;
export type UpdateSolarmanMutationOptions = Apollo.BaseMutationOptions<UpdateSolarmanMutation, UpdateSolarmanMutationVariables>;
export const AddUserPropertySubscriptionDocument = gql`
    mutation AddUserPropertySubscription($recordId: String!, $subscription: SubscriptionInput!) {
  addUserPropertySubscription(recordId: $recordId, subscription: $subscription) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}`;
export type AddUserPropertySubscriptionMutationFn = Apollo.MutationFunction<AddUserPropertySubscriptionMutation, AddUserPropertySubscriptionMutationVariables>;

/**
 * __useAddUserPropertySubscriptionMutation__
 *
 * To run a mutation, you first call `useAddUserPropertySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserPropertySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserPropertySubscriptionMutation, { data, loading, error }] = useAddUserPropertySubscriptionMutation({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      subscription: // value for 'subscription'
 *   },
 * });
 */
export function useAddUserPropertySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<AddUserPropertySubscriptionMutation, AddUserPropertySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserPropertySubscriptionMutation, AddUserPropertySubscriptionMutationVariables>(AddUserPropertySubscriptionDocument, options);
      }
export type AddUserPropertySubscriptionMutationHookResult = ReturnType<typeof useAddUserPropertySubscriptionMutation>;
export type AddUserPropertySubscriptionMutationResult = Apollo.MutationResult<AddUserPropertySubscriptionMutation>;
export type AddUserPropertySubscriptionMutationOptions = Apollo.BaseMutationOptions<AddUserPropertySubscriptionMutation, AddUserPropertySubscriptionMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($email: String!, $input: UpdateUserInput!, $public: Boolean = false) {
  updateUser(email: $email, input: $input, public: $public) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on User {
      ...UserFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      input: // value for 'input'
 *      public: // value for 'public'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateDynamoUserDocument = gql`
    mutation UpdateDynamoUser($email: String!, $input: UpdateDynamoUserInput!) {
  updateDynamoUser(email: $email, input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on User {
      ...UserFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export type UpdateDynamoUserMutationFn = Apollo.MutationFunction<UpdateDynamoUserMutation, UpdateDynamoUserMutationVariables>;

/**
 * __useUpdateDynamoUserMutation__
 *
 * To run a mutation, you first call `useUpdateDynamoUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDynamoUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDynamoUserMutation, { data, loading, error }] = useUpdateDynamoUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDynamoUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDynamoUserMutation, UpdateDynamoUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDynamoUserMutation, UpdateDynamoUserMutationVariables>(UpdateDynamoUserDocument, options);
      }
export type UpdateDynamoUserMutationHookResult = ReturnType<typeof useUpdateDynamoUserMutation>;
export type UpdateDynamoUserMutationResult = Apollo.MutationResult<UpdateDynamoUserMutation>;
export type UpdateDynamoUserMutationOptions = Apollo.BaseMutationOptions<UpdateDynamoUserMutation, UpdateDynamoUserMutationVariables>;
export const AddUserPropertyDocument = gql`
    mutation AddUserProperty($email: String!, $input: AdditionalPropertyInput!) {
  addUserProperty(email: $email, input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on UserAdditionalProperty {
      ...UserAdditionalPropertyFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${UserAdditionalPropertyFragmentFragmentDoc}`;
export type AddUserPropertyMutationFn = Apollo.MutationFunction<AddUserPropertyMutation, AddUserPropertyMutationVariables>;

/**
 * __useAddUserPropertyMutation__
 *
 * To run a mutation, you first call `useAddUserPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserPropertyMutation, { data, loading, error }] = useAddUserPropertyMutation({
 *   variables: {
 *      email: // value for 'email'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddUserPropertyMutation, AddUserPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserPropertyMutation, AddUserPropertyMutationVariables>(AddUserPropertyDocument, options);
      }
export type AddUserPropertyMutationHookResult = ReturnType<typeof useAddUserPropertyMutation>;
export type AddUserPropertyMutationResult = Apollo.MutationResult<AddUserPropertyMutation>;
export type AddUserPropertyMutationOptions = Apollo.BaseMutationOptions<AddUserPropertyMutation, AddUserPropertyMutationVariables>;
export const UpdateUserPropertyDocument = gql`
    mutation UpdateUserProperty($recordId: String!, $input: UpdateUserPropertyInput!) {
  updateUserProperty(recordId: $recordId, input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on UserProperty {
      ...UserPropertyFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${UserPropertyFragmentFragmentDoc}`;
export type UpdateUserPropertyMutationFn = Apollo.MutationFunction<UpdateUserPropertyMutation, UpdateUserPropertyMutationVariables>;

/**
 * __useUpdateUserPropertyMutation__
 *
 * To run a mutation, you first call `useUpdateUserPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPropertyMutation, { data, loading, error }] = useUpdateUserPropertyMutation({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPropertyMutation, UpdateUserPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPropertyMutation, UpdateUserPropertyMutationVariables>(UpdateUserPropertyDocument, options);
      }
export type UpdateUserPropertyMutationHookResult = ReturnType<typeof useUpdateUserPropertyMutation>;
export type UpdateUserPropertyMutationResult = Apollo.MutationResult<UpdateUserPropertyMutation>;
export type UpdateUserPropertyMutationOptions = Apollo.BaseMutationOptions<UpdateUserPropertyMutation, UpdateUserPropertyMutationVariables>;
export const UploadSignedDocumentDocument = gql`
    mutation UploadSignedDocument($input: UpdateUserInput!) {
  uploadSignedDocument(input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on User {
      ...UserFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export type UploadSignedDocumentMutationFn = Apollo.MutationFunction<UploadSignedDocumentMutation, UploadSignedDocumentMutationVariables>;

/**
 * __useUploadSignedDocumentMutation__
 *
 * To run a mutation, you first call `useUploadSignedDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSignedDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSignedDocumentMutation, { data, loading, error }] = useUploadSignedDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadSignedDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadSignedDocumentMutation, UploadSignedDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadSignedDocumentMutation, UploadSignedDocumentMutationVariables>(UploadSignedDocumentDocument, options);
      }
export type UploadSignedDocumentMutationHookResult = ReturnType<typeof useUploadSignedDocumentMutation>;
export type UploadSignedDocumentMutationResult = Apollo.MutationResult<UploadSignedDocumentMutation>;
export type UploadSignedDocumentMutationOptions = Apollo.BaseMutationOptions<UploadSignedDocumentMutation, UploadSignedDocumentMutationVariables>;
export const GenerateSignedDocumentsDocument = gql`
    mutation GenerateSignedDocuments($input: UpdateUserInput!, $subscriptionData: AgreementDataInput!) {
  generateSignedDocuments(input: $input, subscriptionData: $subscriptionData) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on User {
      ...UserFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export type GenerateSignedDocumentsMutationFn = Apollo.MutationFunction<GenerateSignedDocumentsMutation, GenerateSignedDocumentsMutationVariables>;

/**
 * __useGenerateSignedDocumentsMutation__
 *
 * To run a mutation, you first call `useGenerateSignedDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSignedDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSignedDocumentsMutation, { data, loading, error }] = useGenerateSignedDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      subscriptionData: // value for 'subscriptionData'
 *   },
 * });
 */
export function useGenerateSignedDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSignedDocumentsMutation, GenerateSignedDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSignedDocumentsMutation, GenerateSignedDocumentsMutationVariables>(GenerateSignedDocumentsDocument, options);
      }
export type GenerateSignedDocumentsMutationHookResult = ReturnType<typeof useGenerateSignedDocumentsMutation>;
export type GenerateSignedDocumentsMutationResult = Apollo.MutationResult<GenerateSignedDocumentsMutation>;
export type GenerateSignedDocumentsMutationOptions = Apollo.BaseMutationOptions<GenerateSignedDocumentsMutation, GenerateSignedDocumentsMutationVariables>;
export const GetBanksDocument = gql`
    query GetBanks {
  getBanks {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on Banks {
      banks {
        ...BankFragment
      }
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${BankFragmentFragmentDoc}`;

/**
 * __useGetBanksQuery__
 *
 * To run a query within a React component, call `useGetBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBanksQuery(baseOptions?: Apollo.QueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
      }
export function useGetBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
        }
export type GetBanksQueryHookResult = ReturnType<typeof useGetBanksQuery>;
export type GetBanksLazyQueryHookResult = ReturnType<typeof useGetBanksLazyQuery>;
export type GetBanksQueryResult = Apollo.QueryResult<GetBanksQuery, GetBanksQueryVariables>;
export const GetCreditScoreDocument = gql`
    query GetCreditScore($input: CreditCheckInput!) {
  getCreditScore(input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on CreditCheckResponse {
      ...CreditCheckFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${CreditCheckFragmentFragmentDoc}`;

/**
 * __useGetCreditScoreQuery__
 *
 * To run a query within a React component, call `useGetCreditScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditScoreQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCreditScoreQuery(baseOptions: Apollo.QueryHookOptions<GetCreditScoreQuery, GetCreditScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditScoreQuery, GetCreditScoreQueryVariables>(GetCreditScoreDocument, options);
      }
export function useGetCreditScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditScoreQuery, GetCreditScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditScoreQuery, GetCreditScoreQueryVariables>(GetCreditScoreDocument, options);
        }
export type GetCreditScoreQueryHookResult = ReturnType<typeof useGetCreditScoreQuery>;
export type GetCreditScoreLazyQueryHookResult = ReturnType<typeof useGetCreditScoreLazyQuery>;
export type GetCreditScoreQueryResult = Apollo.QueryResult<GetCreditScoreQuery, GetCreditScoreQueryVariables>;
export const GetKmlFileDocument = gql`
    query GetKmlFile($public: Boolean = false) {
  getKml(public: $public) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on KmlFile {
      kml
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}`;

/**
 * __useGetKmlFileQuery__
 *
 * To run a query within a React component, call `useGetKmlFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKmlFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKmlFileQuery({
 *   variables: {
 *      public: // value for 'public'
 *   },
 * });
 */
export function useGetKmlFileQuery(baseOptions?: Apollo.QueryHookOptions<GetKmlFileQuery, GetKmlFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKmlFileQuery, GetKmlFileQueryVariables>(GetKmlFileDocument, options);
      }
export function useGetKmlFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKmlFileQuery, GetKmlFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKmlFileQuery, GetKmlFileQueryVariables>(GetKmlFileDocument, options);
        }
export type GetKmlFileQueryHookResult = ReturnType<typeof useGetKmlFileQuery>;
export type GetKmlFileLazyQueryHookResult = ReturnType<typeof useGetKmlFileLazyQuery>;
export type GetKmlFileQueryResult = Apollo.QueryResult<GetKmlFileQuery, GetKmlFileQueryVariables>;
export const GetFileDocument = gql`
    query GetFile($key: String!) {
  getFile(key: $key) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on File {
      base64
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}`;

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetFileQuery(baseOptions: Apollo.QueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
      }
export function useGetFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>;
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>;
export type GetFileQueryResult = Apollo.QueryResult<GetFileQuery, GetFileQueryVariables>;
export const GetSubscriptionAgreementDocument = gql`
    query GetSubscriptionAgreement($recordId: String!) {
  getSubscriptionAgreement(recordId: $recordId) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on SubscriptionAgreement {
      subscriptionAgreement
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}`;

/**
 * __useGetSubscriptionAgreementQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionAgreementQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useGetSubscriptionAgreementQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionAgreementQuery, GetSubscriptionAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionAgreementQuery, GetSubscriptionAgreementQueryVariables>(GetSubscriptionAgreementDocument, options);
      }
export function useGetSubscriptionAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionAgreementQuery, GetSubscriptionAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionAgreementQuery, GetSubscriptionAgreementQueryVariables>(GetSubscriptionAgreementDocument, options);
        }
export type GetSubscriptionAgreementQueryHookResult = ReturnType<typeof useGetSubscriptionAgreementQuery>;
export type GetSubscriptionAgreementLazyQueryHookResult = ReturnType<typeof useGetSubscriptionAgreementLazyQuery>;
export type GetSubscriptionAgreementQueryResult = Apollo.QueryResult<GetSubscriptionAgreementQuery, GetSubscriptionAgreementQueryVariables>;
export const GetDebitOrderMandateDocument = gql`
    query GetDebitOrderMandate($recordId: String!) {
  getDebitOrderMandate(recordId: $recordId) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on DebitOrderMandate {
      debitOrderMandate
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}`;

/**
 * __useGetDebitOrderMandateQuery__
 *
 * To run a query within a React component, call `useGetDebitOrderMandateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDebitOrderMandateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDebitOrderMandateQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useGetDebitOrderMandateQuery(baseOptions: Apollo.QueryHookOptions<GetDebitOrderMandateQuery, GetDebitOrderMandateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDebitOrderMandateQuery, GetDebitOrderMandateQueryVariables>(GetDebitOrderMandateDocument, options);
      }
export function useGetDebitOrderMandateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDebitOrderMandateQuery, GetDebitOrderMandateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDebitOrderMandateQuery, GetDebitOrderMandateQueryVariables>(GetDebitOrderMandateDocument, options);
        }
export type GetDebitOrderMandateQueryHookResult = ReturnType<typeof useGetDebitOrderMandateQuery>;
export type GetDebitOrderMandateLazyQueryHookResult = ReturnType<typeof useGetDebitOrderMandateLazyQuery>;
export type GetDebitOrderMandateQueryResult = Apollo.QueryResult<GetDebitOrderMandateQuery, GetDebitOrderMandateQueryVariables>;
export const GetMunicpalitiesDocument = gql`
    query GetMunicpalities {
  getMunicipalities {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on Municipalities {
      municipalities {
        ...MunicipalityFragment
      }
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${MunicipalityFragmentFragmentDoc}`;

/**
 * __useGetMunicpalitiesQuery__
 *
 * To run a query within a React component, call `useGetMunicpalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMunicpalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMunicpalitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMunicpalitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetMunicpalitiesQuery, GetMunicpalitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMunicpalitiesQuery, GetMunicpalitiesQueryVariables>(GetMunicpalitiesDocument, options);
      }
export function useGetMunicpalitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMunicpalitiesQuery, GetMunicpalitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMunicpalitiesQuery, GetMunicpalitiesQueryVariables>(GetMunicpalitiesDocument, options);
        }
export type GetMunicpalitiesQueryHookResult = ReturnType<typeof useGetMunicpalitiesQuery>;
export type GetMunicpalitiesLazyQueryHookResult = ReturnType<typeof useGetMunicpalitiesLazyQuery>;
export type GetMunicpalitiesQueryResult = Apollo.QueryResult<GetMunicpalitiesQuery, GetMunicpalitiesQueryVariables>;
export const GetUserSolarmanDeviceDataDocument = gql`
    query getUserSolarmanDeviceData($input: SolarmanDeviceCurrentDataInput!) {
  getUserSolarmanDeviceData(input: $input) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on SolarmanDeviceCurrentDataResponse {
      ...SolarmanDeviceData
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${SolarmanDeviceDataFragmentDoc}`;

/**
 * __useGetUserSolarmanDeviceDataQuery__
 *
 * To run a query within a React component, call `useGetUserSolarmanDeviceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSolarmanDeviceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSolarmanDeviceDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserSolarmanDeviceDataQuery(baseOptions: Apollo.QueryHookOptions<GetUserSolarmanDeviceDataQuery, GetUserSolarmanDeviceDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSolarmanDeviceDataQuery, GetUserSolarmanDeviceDataQueryVariables>(GetUserSolarmanDeviceDataDocument, options);
      }
export function useGetUserSolarmanDeviceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSolarmanDeviceDataQuery, GetUserSolarmanDeviceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSolarmanDeviceDataQuery, GetUserSolarmanDeviceDataQueryVariables>(GetUserSolarmanDeviceDataDocument, options);
        }
export type GetUserSolarmanDeviceDataQueryHookResult = ReturnType<typeof useGetUserSolarmanDeviceDataQuery>;
export type GetUserSolarmanDeviceDataLazyQueryHookResult = ReturnType<typeof useGetUserSolarmanDeviceDataLazyQuery>;
export type GetUserSolarmanDeviceDataQueryResult = Apollo.QueryResult<GetUserSolarmanDeviceDataQuery, GetUserSolarmanDeviceDataQueryVariables>;
export const GetSingleSubscriptionsDocument = gql`
    query GetSingleSubscriptions($productId: String!) {
  getSingleSubscription(productId: $productId) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on Single_Subscription {
      subscription {
        ...SubscriptionFragment
      }
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}`;

/**
 * __useGetSingleSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSingleSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleSubscriptionsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetSingleSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<GetSingleSubscriptionsQuery, GetSingleSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleSubscriptionsQuery, GetSingleSubscriptionsQueryVariables>(GetSingleSubscriptionsDocument, options);
      }
export function useGetSingleSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleSubscriptionsQuery, GetSingleSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleSubscriptionsQuery, GetSingleSubscriptionsQueryVariables>(GetSingleSubscriptionsDocument, options);
        }
export type GetSingleSubscriptionsQueryHookResult = ReturnType<typeof useGetSingleSubscriptionsQuery>;
export type GetSingleSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetSingleSubscriptionsLazyQuery>;
export type GetSingleSubscriptionsQueryResult = Apollo.QueryResult<GetSingleSubscriptionsQuery, GetSingleSubscriptionsQueryVariables>;
export const GetSubscriptionsDocument = gql`
    query GetSubscriptions {
  getSubscriptions {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on Subscriptions {
      subscriptions {
        ...SubscriptionFragment
      }
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}`;

/**
 * __useGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
      }
export function useGetSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export type GetSubscriptionsQueryHookResult = ReturnType<typeof useGetSubscriptionsQuery>;
export type GetSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsLazyQuery>;
export type GetSubscriptionsQueryResult = Apollo.QueryResult<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($email: String!, $public: Boolean = false) {
  getUser(email: $email, public: $public) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on User {
      ...UserFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      email: // value for 'email'
 *      public: // value for 'public'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserPropertyDocument = gql`
    query GetUserProperty($recordId: String!) {
  getUserProperty(recordId: $recordId) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on UserProperty {
      ...UserPropertyFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${UserPropertyFragmentFragmentDoc}`;

/**
 * __useGetUserPropertyQuery__
 *
 * To run a query within a React component, call `useGetUserPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPropertyQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useGetUserPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetUserPropertyQuery, GetUserPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPropertyQuery, GetUserPropertyQueryVariables>(GetUserPropertyDocument, options);
      }
export function useGetUserPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPropertyQuery, GetUserPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPropertyQuery, GetUserPropertyQueryVariables>(GetUserPropertyDocument, options);
        }
export type GetUserPropertyQueryHookResult = ReturnType<typeof useGetUserPropertyQuery>;
export type GetUserPropertyLazyQueryHookResult = ReturnType<typeof useGetUserPropertyLazyQuery>;
export type GetUserPropertyQueryResult = Apollo.QueryResult<GetUserPropertyQuery, GetUserPropertyQueryVariables>;
export const GetUserPropertiesDocument = gql`
    query GetUserProperties($customerNumber: String!) {
  getUserProperties(customerNumber: $customerNumber) {
    ... on ErrorResponse {
      ...ErrorResponseFragment
    }
    ... on UserProperties {
      ...UserPropertiesFragment
    }
  }
}
    ${ErrorResponseFragmentFragmentDoc}
${UserPropertiesFragmentFragmentDoc}`;

/**
 * __useGetUserPropertiesQuery__
 *
 * To run a query within a React component, call `useGetUserPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPropertiesQuery({
 *   variables: {
 *      customerNumber: // value for 'customerNumber'
 *   },
 * });
 */
export function useGetUserPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>(GetUserPropertiesDocument, options);
      }
export function useGetUserPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>(GetUserPropertiesDocument, options);
        }
export type GetUserPropertiesQueryHookResult = ReturnType<typeof useGetUserPropertiesQuery>;
export type GetUserPropertiesLazyQueryHookResult = ReturnType<typeof useGetUserPropertiesLazyQuery>;
export type GetUserPropertiesQueryResult = Apollo.QueryResult<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>;